<script lang="ts">
import { useGlobalStore } from "@/stores/globalStore";
export default {
  setup() {
    const globalStore = useGlobalStore();
    return { globalStore };
  },
};
</script>

<template>
  <ModalItem border background="var(--bg)" class="modal-under">
    <LogoIcon class="connection-logo"/>
    <div class="connection-title">{{ $t("first-connection.title") }}</div>
    <div class="connection-indication">
      {{ $t("first-connection.indication") }}
    </div>

    <div class="connection-input-title">
      {{ $t("first-connection.input-title") }}
    </div>

    <InputItem
      class="connection-input"
      inputType="text"
      :placeholder="$t('first-connection.input-title')"
      v-model="globalStore.userName"
      :design="{
        backgroundColor: 'var(--bg3)',
        color: 'white',
        width: '600px',
      }"
    />
    <ButtonItem
      class="connection-button"
      :msg="$t('first-connection.button')"
      @click="globalStore.updateUserName"
    />
  </ModalItem>
</template>

<style scoped>
.modal-under{
  z-index: 8;
}
.connection-logo {
  width: 100%;
  margin-bottom:2rem;
}
.connection-title {
  font-weight: 700;
  font-size: 1.4rem;
  text-align: center;
  letter-spacing: 0.1rem;
  margin-bottom: 1.5rem;
}
.connection-indication {
  font-weight: 400;
  font-size: 0.9rem;
  text-align: center;
  margin-bottom: 2.5rem;
  color: var(--text-medium-emphasis);
}
.connection-input-title {
  font-weight: 700;
  font-size: 0.8rem;
  margin-bottom: 1rem;
  color: var(--text-medium-emphasis);
}
.connection-button {
  padding: 0.8rem 2rem;
  margin: 2rem auto 0.5rem;
  width: 50%;
}
</style>
